import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { Observable, of } from 'rxjs';

import { CwpComponentRoute, CwpComponentRouteConfig } from '../models/cwp-component-route-config.model';


@Injectable({
	providedIn: 'root'
})
export class CwpComponentResolver implements Resolve<CwpComponentRoute | undefined> {

	@InjectConfig(SharedConfigKey.CWP_COMPONENTS) private readonly cwpComponents: CwpComponentRouteConfig = { routes: [] };

	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CwpComponentRoute | undefined> {
		let cwpRoute;
		if (this.cwpComponents.routes.length) {
			cwpRoute = this.cwpComponents.routes.find(cwpRoute => route.routeConfig?.path === cwpRoute.path);
		}
		return of(cwpRoute);
	}
}
